import type { FolderType } from '../../hooks/usePocket';

interface FolderSelectModalProps {
  onSelect: (folder: FolderType) => void;
  onClose: () => void;
}

export default function FolderSelectModal({ onSelect, onClose }: FolderSelectModalProps) {
  const folders: { value: FolderType; label: string; icon: string; description: string }[] = [
    { value: '출퇴근', label: '출퇴근', icon: '🚇', description: '이동 중에 즐기기' },
    { value: '자기 전', label: '자기 전', icon: '🌙', description: '잠들기 전 한 판' },
    { value: '멍때리기', label: '멍때리기', icon: '😶', description: '쉬는 시간에' },
    { value: '두뇌', label: '두뇌', icon: '🧠', description: '머리 쓰는 게임' }
  ];

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-2xl max-w-md w-full border border-gray-700">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h3 className="text-xl font-bold text-white">폴더 선택</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white transition-colors cursor-pointer text-2xl leading-none"
            >
              ×
            </button>
          </div>

          <div className="space-y-3">
            {folders.map(folder => (
              <button
                key={folder.value}
                onClick={() => onSelect(folder.value)}
                className="w-full bg-gray-700/50 hover:bg-gradient-to-r hover:from-cyan-500/20 hover:to-blue-600/20 border border-gray-600 hover:border-cyan-500 rounded-xl p-4 transition-all text-left cursor-pointer group"
              >
                <div className="flex items-center gap-3">
                  <span className="text-3xl">{folder.icon}</span>
                  <div className="flex-1">
                    <div className="font-semibold text-white group-hover:text-cyan-400 transition-colors">
                      {folder.label}
                    </div>
                    <div className="text-sm text-gray-400">
                      {folder.description}
                    </div>
                  </div>
                  <span className="text-gray-500 group-hover:text-cyan-400 transition-colors">
                    →
                  </span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
